import { render } from "./JudgeListCard.vue?vue&type=template&id=b0877fee&scoped=true"
import script from "./JudgeListCard.vue?vue&type=script&lang=js"
export * from "./JudgeListCard.vue?vue&type=script&lang=js"

import "./JudgeListCard.vue?vue&type=style&index=0&id=b0877fee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0877fee"]])

export default __exports__